<template>
  <div v-if="hasAnyPermission('characteristic-master-view')" class="py-4 container-fluid">
    <ToastPrime position="bottom-left" />
    <div class="card">
      <div class="card-header py-3">
        <div class="row align-items-center">
          <!-- Bagian H3 di Kiri -->
          <div class="col-4">
            <h5 class="mb-0">Characteristic Master</h5>
          </div>

          <!-- Bagian Pencarian di Tengah -->
          <div class="col-4 d-flex justify-content-center">
            <IconField class="w-100">
              <InputIcon>
                <i class="pi pi-search"></i>
              </InputIcon>
              <InputText v-model="table.search" type="text" size="small" placeholder="Search" class="rounded-pill w-100"
                @keyup="filter" />
            </IconField>
          </div>

          <!-- Bagian Button di Kanan -->
          <div class="col-4 text-end">
            <button v-if="hasAnyPermission('characteristic-master-create')" type="button" class="mx-1 mb-0 btn btn-sm btn-primary" @click="openAddModal">Add</button>
          </div>
        </div>
      </div>
      <div style="height: 500px; overflow-y: auto;">
        <DataTable :value="table.onLoad ? dummyRows : table.data" class="datatable-sm text-sm" removable-sort scrollable
          scroll-height="flex" table-style="min-width: 50rem">
          <Column header="Characteristic" header-class="bg-light text-dark" sortable>
            <template v-if="table.onLoad" #body>
              <Skeleton></Skeleton>
            </template>
            <template v-else #body="slotProps">
              {{ slotProps.data && slotProps.data.characteristic ? slotProps.data.characteristic : '' }}
            </template>
          </Column>
          <Column header="Characteristic SAP" header-class="bg-light text-dark" sortable>
            <template v-if="table.onLoad" #body>
              <Skeleton></Skeleton>
            </template>
            <template v-else #body="slotProps">
              {{ slotProps.data && slotProps.data.char_sap ? slotProps.data.char_sap : '' }}
            </template>
          </Column>
          <Column header="Single / Multiple" header-class="bg-light text-dark" sortable>
            <template v-if="table.onLoad" #body>
              <Skeleton></Skeleton>
            </template>
            <template v-else #body="slotProps">
              {{ slotProps.data && slotProps.data.single_or_multiple ? slotProps.data.single_or_multiple : '' }}
            </template>
          </Column>
          <!-- <Column header="Label" header-class="bg-light text-dark" sortable>
            <template v-if="table.onLoad" #body>
              <Skeleton></Skeleton>
            </template>
            <template v-else #body="slotProps">
              {{ slotProps.data && slotProps.data.label ? slotProps.data.label : '' }}
            </template>
          </Column> -->
          <!-- <Column header="Position" header-class="bg-light text-dark" sortable>
            <template v-if="table.onLoad" #body>
              <Skeleton></Skeleton>
            </template>
            <template v-else #body="slotProps">
              {{ slotProps.data && slotProps.data.position ? slotProps.data.position : '' }}
            </template>
          </Column> -->
          <!-- <Column header="Space" header-class="bg-light text-dark" sortable>
            <template v-if="table.onLoad" #body>
              <Skeleton></Skeleton>
            </template>
            <template v-else #body="slotProps">
              {{ slotProps.data && slotProps.data.space ? slotProps.data.space : '' }}
            </template>
          </Column> -->
          <Column header="Actions" header-class="bg-light text-dark" :style="{ width: '150px' }"
            :body-style="{ width: '150px', padding: '0' }">
            <template v-if="table.onLoad" #body>
              <Skeleton />
            </template>
            <template v-else #body="row">
              <div v-if="row.data?.characteristic">
                <ButtonPrime v-if="hasAnyPermission('characteristic-master-update')" v-tooltip.bottom="'Update'" icon="pi pi-pencil" outlined rounded size="small"
                  @click="openEditModal(row.data)" />
                <ButtonPrime v-if="hasAnyPermission('characteristic-master-delete')" v-tooltip.bottom="'Delete'" icon="pi pi-trash" outlined rounded severity="danger"
                  size="small" style="margin-left: 5px;" @click="deleteItem(row.data.id)" />
              </div>
            </template>
          </Column>
          <template #empty>
            <div style="text-align: center; padding: 40px 0;">
              <img src="/no_data.png" alt="No Data" style="max-width: 330px; opacity: 0.7; margin-bottom: 0;" />
              <div style="color: #888; font-size: 1.1em; font-weight: 500;">
                No Data
              </div>
            </div>
          </template>
        </DataTable>
      </div>
      <div class="card-footer pb-0 d-flex justify-content-between align-items-center">
        <BasePagination v-model="table.page.current_pages" :page-count="table.page.total_pages || 1" size="sm"
          @click="changePage()" />
        <p>
          {{ (table.page.current_pages - 1) * table.page.per_pages + table.data.length }} of {{ table.total }}
        </p>
      </div>
    </div>

    <DialogPrime v-model:visible="modal.visible" :header="modal.title" style="width: 30rem; margin: 10px;">
      <template #header>
        <div class="d-flex align-items-center gap-3">
          <div>
            <h5 class="mb-0 fw-bold text-dark">{{ modal.title }}</h5>
          </div>
        </div>
      </template>
      <div class="row g-4">
        <div class="col-12">
          <div class="row g-3">
            <!-- Characteristic -->
            <div class="col-12">
              <label for="characteristic" class="font-semibold">Characteristic <span
                  class="text-danger">*</span></label>
              <InputText id="characteristic" v-model="modal.data.characteristic" placeholder="Characteristic"
                :class="`${(modal.errorMessage['characteristic'] && modal.data.characteristic == '') ? 'border-danger' : ''}`"
                fluid @input="toUpperCaseVal($event, 'characteristic')" />
              <small v-if="modal.errorMessage['characteristic'] && modal.data.characteristic == ''"
                class="text-danger">{{
                  modal.errorMessage['characteristic'] }}</small>
            </div>

            <!-- Characteristic SAP -->
            <div class="col-12">
              <label for="char_sap" class="font-semibold">Characteristic SAP <span
                  class="text-danger">*</span></label>
              <InputText id="char_sap" v-model="modal.data.char_sap" placeholder="Characteristic SAP"
                :class="`${(modal.errorMessage['char_sap'] && modal.data.char_sap == '') ? 'border-danger' : ''}`"
                maxlength="25" fluid @input="replaceSpaceWithUnderscore($event, 'char_sap')" />
              <small v-if="modal.errorMessage['char_sap'] && modal.data.char_sap == ''" class="text-danger">{{
                modal.errorMessage['char_sap'] }}</small>
            </div>

            <!-- Single or Multiple -->
            <div class="col-12">
              <label for="single_or_multiple" class="font-semibold">Single or Multiple <span
                  class="text-danger">*</span></label>
              <SelectPrime id="single_or_multiple" v-model="modal.data.single_or_multiple" :options="optSglMltp"
                option-label="label" option-value="value" placeholder="Please select one"
                :invalid="modal.errorMessage['single_or_multiple'] && modal.data.single_or_multiple === ''"
                class="w-full" fluid />
              <small v-if="modal.errorMessage['single_or_multiple'] && modal.data.single_or_multiple == ''"
                class="text-danger">{{ modal.errorMessage['single_or_multiple'] }}</small>
            </div>
          </div>
        </div>
      </div>

      <template #footer>
        <div class="d-flex justify-content-end gap-2 pt-3 border-top w-100 mt-2 px-1">
          <ButtonPrime type="button" label="Cancel" severity="danger" raised size="small" :disabled="modal.onLoading"
            class="px-4 border-0" @click="modal.visible = false" />
          <ButtonPrime v-if="(modal.action === 'create' && hasAnyPermission('characteristic-master-create')) || (modal.action === 'edit' && hasAnyPermission('characteristic-master-update'))"
            type="button" severity="contrast" raised size="small" :disabled="modal.onLoading || anyEmptyVal"
            label="Save" class="px-4" @click="save()">
            <template v-if="modal.onLoading" #icon>
              <i class="fas fa-spinner fa-spin me-2"></i>
            </template>
          </ButtonPrime>
        </div>
      </template>
    </DialogPrime>
  </div>
  <NoAccess v-else />
</template>

<script>
import { mapState } from "vuex";
import NoAccess from "@/components/NoAccess.vue";
import BasePagination from "@/components/BasePagination.vue";
import api from "@/helpers/api";
import characteristicService from "@/services/dictionary/characteristicService"

export default {
  components: { 
    BasePagination,
    NoAccess, 
  },
  data() {
    return {
      table: {
        search: this.$route.query.search || "",
        onLoad: true,
        total: 0,
        data: [],
        limit: 100,
        page: {
          current_pages: 1,
          per_pages: 10,
          total_pages: 1,
        },
        loadTimeout: null,
      },
      dummyRows: Array.from({ length: 10 }, () => ({})),
      modal: {
        visible: false,
        action: "",
        title: "",
        data: {},
        errorMessage: {},
        onLoading: false,
      },
      itemType: [
        { code: "GEN", description: "GENERAL" },
        { code: "OEM", description: "ORIGINAL EQUIPMENT MANUFACTURE" },
        { code: "SERV", description: "SERVICE" },
        { code: "GEN_OEM", description: "GENERAL OR OEM" },
        { code: "TMP", description: "TEMPORARY" },
      ],
      optSglMltp: [{ label: "Multiple", value: "MULTIPLE" }, { label: "Single", value: "SINGLE" }],
      optSpace: [{ label: "Yes", value: "YES" }, { label: "No", value: "NO" }],
      optPosLabel: [{ label: "Before", value: "BEFORE" }, { label: "After", value: "AFTER" }],
    };
  },
  computed: {
    ...mapState({
      authUserPermissions: (state) => state.auth.userHasPermissions || [],
    }),
    anyEmptyVal() {
      return (!this.modal.data.characteristic || !this.modal.data.char_sap || !this.modal.data.single_or_multiple);
    }
  },
  watch: {
    'modal.data.characteristic'(newVal) {
      if (this.modal.action === 'create') {
        const transformed = (newVal || '')
          .toUpperCase()
          .replace(/\s/g, '_')
          .slice(0, 25);
        this.modal.data.char_sap = transformed;
      }
    }
  },
  mounted() {
    if (this.hasAnyPermission('characteristic-master-view')) {
      this.get();      
    }
  },
  methods: {
    hasAnyPermission(...perms) {
      return perms.some((p) => this.authUserPermissions.includes(p));
    },
    async get() {
      this.table.onLoad = true;
      try {
        const response = await api(this, characteristicService.list({
          limit: this.table.limit,
          page: this.table.page.current_pages,
          search: this.table.search,
          sort_by: 'characteristic',
          sort_order: 'asc'
        }), false);

        const paged = response.data || {};
        this.table.data = paged.data || [];
        this.table.total = paged.total ?? this.table.data.length;
        this.table.page.total_pages = paged.last_page || 1;
        this.table.page.current_pages = paged.current_page || 1;
        this.table.page.per_pages = paged.per_page || this.table.limit;
      } catch (error) {
        this.table.data = [];
        this.table.total = 0;
        this.table.page.total_pages = 1;
      } finally {
        this.table.onLoad = false;
      }
    },
    openAddModal() {
      this.modal = {
        visible: true,
        action: "create",
        title: "Add Characteristic Master",
        data: { characteristic: "", char_sap: "", single_or_multiple: "" },
        errorMessage: {},
        onLoading: false,
      }
    },
    async openEditModal(item) {
      this.modal = {
        visible: true,
        action: "edit",
        title: "Edit Characteristic Master",
        data: {
          ...item,
          // Normalisasi uppercase untuk SelectPrime
          single_or_multiple: item.single_or_multiple ? String(item.single_or_multiple).toUpperCase() : '',
        },
        errorMessage: {},
        onLoading: false,
      };
    },
    deleteItem(id) {
      this.confirmDialog("You won't be able to revert this!", "delete it").then((result) => {
        if (result.isConfirmed) {
          api(this, characteristicService.delete(id)).then(() => { this.get() });
        }
      });
    },
    save() {
      let isValid = true;
      const requiredField = [{ key: "characteristic", message: "Characteristic" }, { key: "char_sap", message: "Characteristic SAP" }, { key: "single_or_multiple", message: "Single or Multiple" }];
      requiredField.forEach((val) => {
        if (!this.modal.data[val.key]) {
          this.modal.errorMessage[val.key] = `${val.message} is required`;
          isValid = false;
        }
      })
      if (!isValid) return false;

      this.modal.onLoading = true
      setTimeout(async () => {
        try {
          const payload = { ...this.modal.data };

          if (this.modal.action === 'create') {
            await api(this, characteristicService.create(payload));
          } else if (this.modal.action === 'edit') {
            delete payload.code;
            await api(this, characteristicService.update(payload.id, payload))
          }
          this.modal.data = {};
          this.modal.visible = false;
          this.get();
        } catch (error) {
          this.handleErrorObjectNested(error)
        } finally {
          this.modal.onLoading = false
        }
      }, 500)
    },
    filter() {
      clearTimeout(this.table.loadTimeout);
      this.table.loadTimeout = setTimeout(() => {
        this.$router.push({ query: this.table.search ? { search: this.table.search } : null });
        this.table.page.current_pages = 1;
        this.get();
      }, 500);
    },
    changePage() {
      this.get();
    },
    toUpperCaseVal(event, key) {
      const input = event.target;
      const start = input.selectionStart;
      const end = input.selectionEnd;

      const upper = input.value.toUpperCase();
      this.modal.data[key] = upper;

      this.$nextTick(() => {
        input.setSelectionRange(start, end);
      });
    },
    replaceSpaceWithUnderscore(event, key) {
      const input = event.target;
      const start = input.selectionStart;
      const end = input.selectionEnd;

      // Replace space with underscore and convert to uppercase
      const transformed = input.value.toUpperCase().replace(/\s/g, '_');
      this.modal.data[key] = transformed;

      this.$nextTick(() => {
        input.setSelectionRange(start, end);
      });
    },
    handleErrorObjectNested(error) {
      if (error.response?.data?.code == 400 || error.response?.status == 422 || error.response?.status == 500) {
        const errorData = error.response?.data?.data;

        if (typeof errorData === 'object' && errorData !== null) {
          for (const key in errorData) {
            if (Object.prototype.hasOwnProperty.call(errorData, key)) {
              const match = key.match(/^items\.(\d+)\.(.+)$/);
              if (match) {
                error.response.data.data[key].forEach(message => {
                  this.$toastNotifPrime('error', error.response.data.message, `${message} in row ${parseInt(match[1]) + 1}`)
                })
              } else {
                this.$toastNotifPrime('error', error.response.data.message, errorData[key]);
                // errorData[key].forEach(message => {
                //   this.$toastNotifPrime('error', error.response.data.message, message);
                // });
              }
            }
          }
        }
      }
    },
  },
};
</script>
